export const CONCEPTOS_PAGO_NO_PROVEEDOR = {
  IVA: "IVA",
  ARCA: "ARCA",
  DREI: "DREI",
  VEP: "VEP",
  SINDICATOS: "sindicatos",
  SELLADOS: "sellados",
  PAGOS_LEGALES: "pagos_legales",
  OTROS: "otros",
};

export const CONCEPTOS_OPTIONS = [
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.IVA, label: "IVA" },
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.ARCA, label: "ARCA" },
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.DREI, label: "DREI" },
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.VEP, label: "VEP" },
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.SINDICATOS, label: "Sindicatos" },
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.SELLADOS, label: "Sellados" },
  {
    value: CONCEPTOS_PAGO_NO_PROVEEDOR.PAGOS_LEGALES,
    label: "Pagos legales",
  },
  { value: CONCEPTOS_PAGO_NO_PROVEEDOR.OTROS, label: "Otros" },
];

export const labelConcepto = (concepto) => {
  const found = CONCEPTOS_OPTIONS.find((o) => o.value === concepto);
  return found?.label ?? concepto ?? "—";
};

const ABREV_CONCEPTO = {
  [CONCEPTOS_PAGO_NO_PROVEEDOR.IVA]: "IVA",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.ARCA]: "ARCA",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.DREI]: "DREI",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.VEP]: "VEP",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.SINDICATOS]: "Sind",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.SELLADOS]: "Sell",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.PAGOS_LEGALES]: "PLeg",
  [CONCEPTOS_PAGO_NO_PROVEEDOR.OTROS]: "Otro",
};

/** Abreviatura de concepto PNP; si no hay mapa, recorta el texto. */
export const abrevConcepto = (concepto) => {
  if (concepto == null || String(concepto).trim() === "") return "";
  const key = String(concepto).trim();
  if (ABREV_CONCEPTO[key]) return ABREV_CONCEPTO[key];
  const label = labelConcepto(key);
  const recorte = String(label === "—" ? key : label).replace(/\s+/g, "");
  return recorte.slice(0, 4);
};
